export const activeSearchByName = () => {
    return {
        type: 'CHANGE_SEARCH_BY_NAME',
        byName: true
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SearchByName/actions.js